import { render, staticRenderFns } from "./OnneHomeCardItem.vue?vue&type=template&id=222e90fd&scoped=true&"
import script from "./OnneHomeCardItem.vue?vue&type=script&lang=js&"
export * from "./OnneHomeCardItem.vue?vue&type=script&lang=js&"
import style0 from "./OnneHomeCardItem.vue?vue&type=style&index=0&id=222e90fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222e90fd",
  null
  
)

export default component.exports